module.exports = __webpack_public_path__ + "media/images/countrysquared/mu-398fff93826c877533d482007225f107.svg";